import { useEffect, useLayoutEffect, useRef } from 'react'

// Calls onDismiss when a pointer press lands outside every element in `refs`.
//
// `event` picks when: 'mousedown' (default) suits overlays (popovers, menus):
// closing one doesn't move the page. Pass 'click' for an inline list in the
// page flow: closing it moves everything below it up, and on mousedown the
// button being clicked slides out from under the pointer before mouseup, so
// its click never fires (the post composer's Continue under the market search, #302).
export function useDismissOnOutside(refs, onDismiss, { enabled = true, event = 'mousedown' } = {}) {
  const latest = useRef({ refs, onDismiss })
  useLayoutEffect(() => {
    latest.current = { refs, onDismiss }
  })

  useEffect(() => {
    if (!enabled) return undefined
    const handler = (domEvent) => {
      const inside = latest.current.refs.some((ref) => ref?.current?.contains(domEvent.target))
      if (!inside) latest.current.onDismiss(domEvent)
    }
    document.addEventListener(event, handler)
    return () => document.removeEventListener(event, handler)
  }, [enabled, event])
}
